
import { Component, Mixins } from "vue-property-decorator";
import { TextPropertyEditableMixin } from "../../../mixins";
import { default as RectangleCoordinatableObjectDrawerBase } from "./RectangleCoordinatableObjectDrawerBase.vue";

@Component
export default class TextPresentableObjectDrawerBase extends Mixins(RectangleCoordinatableObjectDrawerBase, TextPropertyEditableMixin) {
}
